import React from 'react'

export function ReviewsBox({ stores }) {
  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="reviews-box px-3 py-2 m-2 col-md-10">
          {
            stores.map((store, x) => (
              <div key={x} className="pt-3" data-romw-token={store.platforms.reviews.list_token}></div>
            ))
          }
        </div>
      </div>
    </div>
  )
}

export default ReviewsBox
